import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "IL_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#IL_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "IL_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "g",
    {
      mask: "url(#IL_svg__b)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3D58DB"
    },
    /* @__PURE__ */ e.createElement("path", { d: "M0 3v3h32V3H0zM0 18v3h32v-3H0zM11.38 14.939h9.378L16.116 6.62 11.38 14.94zm7.772-1.01H13.02l3.087-5.469 3.046 5.47z" }),
    /* @__PURE__ */ e.createElement("path", { d: "M11.264 9.076h9.416l-4.544 8.085-4.872-8.085zm7.781.974h-5.994l3.058 5.481 2.936-5.48z" })
  ))
);
export {
  t as default
};
